import { render } from "./UserJobs.vue?vue&type=template&id=574d6c54"
import script from "./UserJobs.vue?vue&type=script&lang=js"
export * from "./UserJobs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Saad/Documents/GitHub/link-portal/link/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__